'use client';

import { Button } from '@shared/components/shadcn';
import { ArrowRight, Close } from '@shared/icons';
import Link from 'next/link';
import { Logo } from '../Header/Logo/Logo';

type SimplifiedHeaderProps = {
  showButton?: boolean;
  showCloseButton?: boolean;
  href?: string;
  buttonText?: string;
  logoLink: string;
};

function SimplifiedHeader({ showButton = false, showCloseButton = false, href, buttonText, logoLink }: SimplifiedHeaderProps) {
  return (
    <header className="ll-grid-container relative z-50 md:sticky md:top-0 bg-background">
      <div className="ll-container-inner grid grid-cols-3 xl:grid-cols-12 items-center">
        <div className="col-span-1 col-start-1 py-5">
          <Link href={logoLink}>
            <Logo isLoggedIn={false} />
          </Link>
        </div>
        <div className="col-span-2 col-start-2  xl:col-start-10 xl:col-span-3 justify-self-end py-3 flex flex-row items-center">
          {showButton && (
            <Button variant="ghost" size="s" asChild>
              <Link href={href || '/'} data-track-name="Site">
                <span className="text-foreground pr-2">{buttonText}</span>
                <ArrowRight size="small" />
              </Link>
            </Button>
          )}
          {showCloseButton && (
            <Button variant="ghost" size="s" asChild>
              <Link href={href || '/'}>
                <Close size="small" />
                <span className="sr-only" data-testid="close-button">
                  Close
                </span>
              </Link>
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}

export { SimplifiedHeader };
